import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, Modal, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextUserInfo } from "../../../Layout/MainLayout";
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from "../../../Components/CustomDateInput";
import DateObject from "react-date-object";
import RtlProvider from "../../../Components/RtlProvider"
import helper from "../../../helper";
import { FaRegFileAlt } from "react-icons/fa";
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ImFileExcel } from "react-icons/im";
import moment from 'jalali-moment'
import '../../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../../api/brokerGroupApi";
import FlightPassenger from "./FlightPassenger";
import EnumMapper from "../../../EnumMapper";
import FlightManifest from "./FlightManifest";
import AccessControl from "../../../Components/AccessControl";
import passengerApi from "../../../api/passengerApi";
import CustomTitle from "../../../Components/CustomTitle";




const FlightPanel = () => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [data, setData] = useState([]);
    const [loadingExport, SetLoadingExport] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [flightType, setFlightType] = useState([]);
    const [brokerIDS, setBrokerIDS] = useState([]);

    const flightStatus = [{ id: 1, label: 'نامشخص' }, { id: 2, label: 'تایید شده' }]


    //table state


    const [columnFilters, setColumnFilters] = useState(
        [],
    );
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });


    const columns = useMemo(
        () => [

            {
                accessorKey: 'data.flightNo',
                id: 'flightNo',
                header: 'شماره پرواز',
                enableSorting: false,
            },
                        {
                accessorKey: 'data.tripTypeTitle',
                id: 'tripTypeTitle',
                header: 'نوع پرواز',
                enableSorting: true,
            },
            {
                accessorKey: 'data.originStationName',
                id: 'originStationName',
                header: 'ایستگاه مبدا',
                enableSorting: true,
            },
            {
                accessorKey: 'data.destinationStationName',
                id: 'destinationStationName',
                header: 'ایستگاه مقصد',
                enableSorting: true,
            },
            {
                accessorKey: 'data.airLineTypeTitle',
                id: 'airLineTypeTitle',
                header: 'شرکت پروازی',
                enableSorting: true,
            },
            {
                accessorKey: 'data.flightDatePersian',
                id: 'flightDatePersian',
                header: 'تاریخ پرواز',
                enableSorting: true,
            },
            {
                accessorKey: 'data.flightTime',
                id: 'flightTime',
                header: 'ساعت پرواز',
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    row.original.data?.flightTimeReal ? row.original.data?.flightTimeReal : row.original.data?.flightTime
                ),
            },

            {
                accessorKey: 'data.flightCapacity',
                id: 'flightCapacity',
                header: 'ظرفیت پرواز',
                enableSorting: false,
               
            },
            {
                accessorKey: 'data.notCanceledPassengers',
                id: 'notCanceledPassengers',
                header: 'تعداد زائر تایید شده',
                enableSorting: false,
            },
            {
                accessorKey: 'data.flightDateReal',
                id: 'flightDateReal',
                header: 'وضعیت',
                enableSorting: false,
                Cell: ({ cell, row }) => (
                    row.original.data?.flightDateReal ? 'تایید شده' : 'نامشخص'
                ),
            }


        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enableFilters: false,
        enableRowSelection: false,
        enableExpandAll: false,
        getRowId: (row) => row.flightId,
        initialState: { showColumnFilters: true },
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        muiToolbarAlertBannerProps: isError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        rowCount,
        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        },

        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                backgroundColor: 'rgb(113, 185, 172)',
                textAlign: 'right'
            },
        },
        muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            sx: {
                textAlign: 'right',
            },
        }),
        muiTableBodyProps: {
            sx: {
                //stripe the rows, make odd rows a darker color
                '& tr:nth-of-type(odd) > td': {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
        enableRowActions: true,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: ' ', //change header text
            },
      'mrt-row-expand': {
        header: '', //change header text
        muiTableHeadCellProps: {
          align: 'right',
        },
        muiTableBodyCellProps: {
          align: 'right',
        },
      },
        },
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
            (AccessControl.checkPermissions(userPermissions, ["Flight:GetFlightReportManifestById"])) && <div dir="rtl">

                <Box >
                    {row.original.data?.flightDateReal && <Tooltip title=" مشاهده مانیفست پرواز" placement="top">
                        <IconButton style={{ margin: '1px', borderRadius: 0 }} onClick={() => {
                            handleOpenManifestModal(row.original.data?.flightId);
                        }}>
                            <FaRegFileAlt color='#4a148c' />
                        </IconButton>
                    </Tooltip>}
                </Box>

            </div>
        ),
      
        renderDetailPanel: ({ row }) =>

        ((row.original.data.totalGroup > 0 )||(row.original.data.totalGuestPassengers> 0)||(row.original.data.totalFreePassengers> 0))? (
                <Box
                    sx={{

                        margin: 'auto',
                        width: '100%',
                    }}
                >

                    <FlightPassenger row={row.original.data} RefreshGrid={RefreshGrid} />
                </Box>) : null

    });
    //manifest
    const [openManifestModal, setOpenManifestModal] = useState(false);
    const [selectedFlightId, setSelectedFlightId] = useState(null);
    const handleOpenManifestModal = (flightid) => {
        setSelectedFlightId(flightid);
        setOpenManifestModal(true);
    }
    const handleCloseManifestModal = () => {
        setSelectedFlightId(null);
        setOpenManifestModal(false);
    }

    //export to excel
    const workSheetName = 'Sheet1';
    const workbook = new Excel.Workbook();
    const GetFlightype = () => {
        brokerGroupApi.GetFlightTypeDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setFlightType(arr.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                }));
            })
            .catch((error) => console.log(error));
    }
    useEffect(() => {
        GetFlightype();
    }, []);

    const GetExportData = (paginationData, totalcount) => {
        var clmns = [];
        var filename = '';
        filename = 'لیست پروازها'
        clmns = [
            { header: 'شماره پرواز', key: 'flightNo' },
            { header: 'تاریخ پرواز', key: 'flightDatePersian' },
            { header: 'ساعت پرواز', key: 'flightTime' },
            { header: 'ایستگاه مبدا', key: 'originFlightStationName' },
            { header: 'ایستگاه مقصد', key: 'destinationStationName' },
            { header: 'شرکت پروازی', key: 'airLineTypeTitle' },
        ]
        paginationData.pageNumber = 1;
        paginationData.pageSize = totalcount;
        SetLoadingExport(true);
        brokerGroupApi.GetFlightFilter(paginationData)
            .then((outdata) => {
                const ExpData = outdata.data.data ? outdata.data.data.items.map(itm => { return itm.data }) : [];
                saveExcel(ExpData, clmns, filename);

            })
            .catch((error1) => {
                console.log(error1);
                setIsError(true);
            })
            .finally(() => {
                SetLoadingExport(false);
            })

    }
    const handleExportClick = async () => {

        const paginationData = getfilteritems();
        if (!data.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        brokerGroupApi.GetFlightFilter(paginationData)
            .then((data) => {

                setData(data.data.data ? data.data.data.items : []);
                const rowcnt = data.data.data ? data.data.data.totalCount : 0;
                setRowCount(rowcnt);
                GetExportData(paginationData, data.data.data.totalCount);
            })
            .catch((error) => {
                console.log(error);
                setIsError(true);
            }).finally(() => {
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            });
    }

    const saveExcel = async (expData, columns, workBookName) => {
        try {
            const fileName = workBookName;

            // creating one worksheet in workbook
            const worksheet = workbook.addWorksheet(workSheetName);
            worksheet.views = [{ rightToLeft: true }];
            // add worksheet columns
            // each columns contains header and its mapping key from data
            worksheet.columns = columns;

            // updated the font for first row.
            worksheet.getRow(1).font = { bold: true };

            // loop through all of the columns and set the alignment with width.
            worksheet.columns?.forEach(column => {
                if (column.name === '')
                    column.width = column.header.length + 5;
                column.alignment = { horizontal: 'center' };
            });

            // loop through data and add each one to worksheet
            expData?.forEach(singleData => {
                worksheet.addRow(singleData);
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, row => {
                // store each cell to currentCell
                const currentCell = row._cells;

                // loop through currentCell to apply border only for the non-empty cell of excel
                currentCell.forEach(singleCell => {
                    // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                    const cellAddress = singleCell._address;
                    singleCell.numFmt = '@'
                    // apply border
                    // worksheet.getCell(cellAddress).border = {
                    //   top: { style: 'thin' },
                    //   left: { style: 'thin' },
                    //   bottom: { style: 'thin' },
                    //   right: { style: 'thin' }
                    // };
                });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();

            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
        } catch (error) {
            console.error('<<<ERRROR>>>', error);
            console.error('Something Went Wrong', error.message);
        } finally {
            // removing worksheet's instance to create new one
            workbook.removeWorksheet(workSheetName);
        }
    };
    //form and getdata
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });
    const GetBrokers = () => {
        passengerApi.GetBrokers().then((res) => {

            const arr = helper.DictionayToList(res.data.data);
            setBrokerIDS(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        }
        )
            .catch((error) => {
                console.log(error);
            })
    }

    const getfilteritems = () => {
        const brokerID = watch("brokerID") ? watch("brokerID") : null
        const flightNo = watch("flightNo") ? watch("flightNo") : null

        let flightDateFromGregorian = null;
        if (watch("flightDateFrom")) {
            let flightDate = new DateObject({
                date: watch("flightDateFrom"),
                calendar: persian,
                locale: persian_fa
            });

            var flightDateFromStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
            flightDateFromGregorian = moment.from(flightDateFromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        let flightDateToGregorian = null;
        if (watch("flightDateTo")) {
            let flightDate = new DateObject({
                date: watch("flightDateTo"),
                calendar: persian,
                locale: persian_fa
            });

            var flightDateToStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
            flightDateToGregorian = moment.from(flightDateToStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }
        let flightType = null;
        if (watch("flightTypeID")) {
            flightType = watch("flightTypeID");
            if ((parseInt(flightType) !== parseInt(EnumMapper.FlightType.Departure)) && (parseInt(flightType) !== parseInt(EnumMapper.FlightType.Return)))
                flightType = null;
        }
        let isconfirm = null;
        if (watch("flightStatusID")) {
            isconfirm = watch("flightStatusID") === 1 ? false : true;
        }
        const paginationData = {
            "flightNo": flightNo,
            "brokerID": brokerID,
            "from": flightDateFromGregorian,
            "type": parseInt(flightType),
            // "fromTime": data.flightHourFrom,
            "to": flightDateToGregorian,
            // "toTime": data.flightHourTo,
            "isConfirm": isconfirm,
            "orderBy":sorting.length > 0 ? sorting[0].id: 'flightDate',
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageNumber": pagination.pageIndex + 1,
            "pageSize": pagination.pageSize,
        }
        return paginationData;
    }
    const GetData = () => {
        table.setExpanded({});
        const paginationData = getfilteritems();
        if (!data.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        brokerGroupApi.GetFlightFilter(paginationData)
            .then((data) => {
                setData(data.data.data ? data.data.data.items : []);
                const rowcnt = data.data.data ? data.data.data.totalCount : 0;
                setRowCount(rowcnt);

            })
            .catch((error) => {
                console.log(error);
                setIsError(true);
            }).finally(() => {
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            });
    };
    // const GetFlightTypeDropDown=()=>{
    //     brokerGroupApi.GetFlightTypeDropDown()
    //         .then((res) => {
    //           const arr = helper.DictionayToList(res.data.data);
    //               setFlightTypeid(arr.map((o) => {
    //                 return {
    //                   id: o.key,
    //                   label: flightType[o.key]
    //                 };
    //               }));
    //               })
    //               .catch((error1) => {
    //                 console.log(error1);
    //                 setIsError(true);
    //               })
    // }

    const onSubmit = () => {
        GetData();
    };
    const RefreshGrid = () => {
        GetData();
    }
    useEffect(() => {
        GetBrokers();
    }
        , []);
    useEffect(() => {
        GetData();

    }, [
        columnFilters, //re-fetch when column filters change
        globalFilter, //re-fetch when global filter changes
        pagination.pageIndex, //re-fetch when page index changes
        pagination.pageSize, //re-fetch when page size changes
        sorting, //re-fetch when sorting changes

    ]);
    

    const modalStyle = {
        position: 'absolute',
        display: 'flex',
        overflowX: 'auto',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        pt: 2,
        px: 2,
        pb: 2,
        height: '100%',
        overflow: 'scroll',

    };

    return (
        <>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                          <CustomTitle title={'لیست پرواز'}  />

                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item md={1.5} xs={3.5}>

                                <RHFAutocomplete
                                    control={control}
                                    options={flightType}
                                    name="flightTypeID"
                                    placeholder="نوع پرواز"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                            </Grid>
                            <Grid item md={1.5} xs={3.5} >
                                <TextField
                                    label="شماره پرواز"
                                    {...register("flightNo")}
                                />
                            </Grid>
                            <Grid item md={2.5} >
                                <RHFAutocomplete
                                    control={control}
                                    options={brokerIDS}
                                    name="brokerID"
                                    placeholder="شماره کاروان"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                            </Grid>
                            <Grid item md={1.5} xs={3.5}>
                                <Controller
                                    control={control}
                                    name="flightDateFrom"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, name, value },
                                        fieldState: { invalid, isDirty },
                                    }) => (
                                        <>
                                            <DatePicker
                                                value={value || ""}
                                                onChange={(date) => {
                                                    onChange(date?.isValid ? date : "");
                                                }}
                                                format={"YYYY/MM/DD"}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                render={<CustomDateInput label={" از تاریخ پرواز"} />}
                                            />
                                        </>
                                    )}
                                />
                            </Grid>

                            <Grid item md={1.5} xs={3.5}>
                                <Controller
                                    control={control}
                                    name="flightDateTo"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, name, value },
                                        fieldState: { invalid, isDirty },
                                    }) => (
                                        <>
                                            <DatePicker
                                                value={value || ""}
                                                onChange={(date) => {
                                                    onChange(date?.isValid ? date : "");
                                                }}
                                                format={"YYYY/MM/DD"}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                render={<CustomDateInput label={"تا تاریخ پرواز"} />}
                                            />
                                        </>
                                    )}
                                />
                            </Grid>
                            {/* <Grid item md={1} xs={2}>
                                <Controller
                                    control={control}
                                    name="flightHourFrom"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, name, value },
                                        fieldState: { invalid, isDirty },
                                    }) => (
                                        <>
                                            <DatePicker
                                                disableDayPicker
                                                format="HH:mm"
                                                value={value || ""}
                                                onChange={(date) => {
                                                    onChange(date?.isValid ? date : "");
                                                }}
                                                plugins={[
                                                    <TimePicker hideSeconds />
                                                ]}
                                                // format={"YYYY/MM/DD"}
                                                // calendar={persian}
                                                // locale={persian_fa}
                                                // calendarPosition="bottom-right"
                                                render={<CustomDateInput label={"از ساعت پرواز"} />}
                                            />
                                        </>
                                    )}
                                />
                            </Grid>
                            <Grid item md={1} xs={2}>
                                <Controller
                                    control={control}
                                    name="flightHourTo"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, name, value },
                                        fieldState: { invalid, isDirty },
                                    }) => (
                                        <>
                                            <DatePicker
                                                disableDayPicker
                                                format="HH:mm"
                                                value={value || ""}
                                                onChange={(date) => {
                                                    onChange(date?.isValid ? date : "");
                                                }}
                                                plugins={[
                                                    <TimePicker hideSeconds />
                                                ]}
                                                // format={"YYYY/MM/DD"}
                                                // calendar={persian}
                                                // locale={persian_fa}
                                                // calendarPosition="bottom-right"
                                                render={<CustomDateInput label={"تا ساعت پرواز"} />}
                                            />
                                        </>
                                    )}
                                />
                            </Grid> */}
                            <Grid item md={1.5} xs={3.5}>

                                <RHFAutocomplete
                                    control={control}
                                    options={flightStatus}
                                    name="flightStatusID"
                                    placeholder="وضعیت"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                                <Button type="submit" variant="contained" color="primary"  >
                                    جستجو
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </RtlProvider>
                <div dir="rtl">
                    <Box sx={{ textAlign: 'left', dir: 'rtl' }}>
                        <Tooltip title="دانلود اکسل" placement="top">
                            <IconButton disabled={loadingExport || isLoading} type="button" onClick={() => { handleExportClick(1) }}>
                                {(loadingExport || isLoading) && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                <ImFileExcel color='#04636E' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Typography ><Box sx={{ textAlign: 'left', dir: 'rtl' }}> {'تعداد نتایج' + ' : ' + rowCount} </Box></Typography>

                    <Box sx={{ marginTop: 1 }} >
                        <MaterialReactTable table={table} 
                         />
                    </Box>
                </div>

                <Modal
                    alignItems='center'
                    open={openManifestModal}
                    onClose={handleCloseManifestModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modalStyle}>

                        <FlightManifest flightId={selectedFlightId} />

                    </Box>
                </Modal>
                
            </ThemeProvider>
        </>
    )
}

export default FlightPanel